/* 曹操傳・第 9 章：白狼山（207 年）
 * 曹軍從西南出盧龍塞，在山谷裡走很遠的路；東北是白狼山，山頂可以望見東邊平野上的烏桓大軍。 */
export const HILL = [6900, 1500], TADUN = [8600, 2300], SUPPLY = [[2200, 3700], [3300, 2600], [4400, 3300], [5200, 2200], [6000, 2800]];
export default {
  id: 'bailang', name: '白狼山', W: 9800, H: 5000, seed: 207,
  bases: [[900, 4300], TADUN],
  roads: [{ pts: [[900, 4300], [2200, 3800], [3300, 2700], [4400, 3200], [5200, 2300], [6200, 1900], HILL], w: 110 }, { pts: [HILL, [7700, 1900], TADUN], w: 140 }],
  rocks: [[1800, 2600, 600, 300], [3000, 4300, 600, 260], [4200, 1700, 600, 300], [5500, 4000, 600, 280], [6400, 3200, 420, 220], [7200, 700, 520, 240], [6100, 1200, 260, 140]],
  woods: 0.55,
  sight: 0.75,
  clearings: [[HILL[0], HILL[1], 420], [TADUN[0], TADUN[1], 1000], [900, 4300, 400], ...SUPPLY.map(([x, y]) => [x, y, 200])],
  tents: [{ x: TADUN[0] + 200, y: TADUN[1], n: 12, r: 700, chief: true, col: '#6a6a7a', flag: '烏' }],
  grass: [[2700, 3200, 220, 100], [4800, 2700, 220, 100], [6500, 2300, 220, 100]],
};
